import { isPlatformBrowser, NgClass, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  ElementRef,
  HostListener,
  inject,
  linkedSignal,
  OnInit,
  PLATFORM_ID,
  signal,
  ViewChild,
} from '@angular/core';
import {
  Alert,
  ALERT_ICON_BY_TITLE,
  AlertType,
  AlertUrlConfig,
  careerResourceItem,
  InterViewType,
  jobsItem,
  Message,
  mybdjobsItem,
  nmMap,
  profileMenuItems,
  Reminder,
} from '../utils/nav.const';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { LocalstorageService } from '../../services/essentials/localstorage.service';
import { CookieService } from '../../services/cookie/cookie.service';
import {
  BdjobsSigninUrl,
  Cookies,
  DashboardUrl,
  EMPLOYER_INTEREST,
  EMPLOYER_MSG_URL,
  EMPLOYER_VIEWED_CV,
  HOME_SIGNOUT_URL,
  InterView_DETAILS_URL,
  NotificationUrl,
  PricingPageUrl,
  VideoCVUrl,
} from '../../../shared/enums/app.enums';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterLink } from '@angular/router';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { SharedService } from '../../../features/jobs/services/shared.service';
import { JobDetailService } from '../../../features/details/services/job-details.service';
import {
  ImgVersionParams,
} from '../utils/promotional-banner';
import { DeviceDetectionService } from '../../services/device-detection';
import { HomeNav } from '../../../shared/components/home-nav/home-nav';
import {
  catchError,
  filter,
  finalize,
  map,
  startWith,
  switchMap,
  tap,
} from 'rxjs/operators';
import { TimePipe } from '../../pipes/time-pipe';
import {
  EventStatus,
  UserObj,
  Value,
} from '../../../features/details/models/details.model';
import { NavServices } from '../../services/navServices/nav-services';
import { ToasterService } from '../../../shared/services/toaster.service';
import { ALL_NOTIFICATIONS, EMPLOYER_MSG, JOBS_URL, MATCHED_JOB, RESUME_SELECTED, RESUME_VIEWED, VIDEO_RESUME, VIDEO_RESUME_SUGGESTED, VIDEO_RESUME_WATCHED } from '../../../shared/consts/shared.const';
import { TruncatePipe } from '../../../shared/pipes/truncate.pipe';
import { InitialsPipe } from '../../../shared/pipes/Initials.pipe';
import { EMPTY, of, Subject } from 'rxjs';
import { ToBanglaNumberPipe } from '../../../shared/pipes/toBanglaNumber.pipe';
import { accordionAnimation, dropdownAnimation } from '../../../shared/animation/animation';
import { ResponsiveNav } from "../responsive-nav/responsive-nav";
import { constructRedirectURL, isMaintenaceActive } from '../../../features/jobs/utils/functions';
import { InvalidEventResponseType, NotificationType } from '../../../shared/utils/app.const';
import { ScrollService } from '../../services/scroll/scroll.service';
import { BannerConfigService } from '../../../shared/services/banner.service';
import { MaintenaceBanner } from '../../../shared/models/banner.models';
import { FairService } from '../../../shared/services/fair.service';
import { ProfileCompletionService } from '../../../features/home/services/profile-completion.service';
import { NgxSkeletonLoaderComponent } from "ngx-skeleton-loader";
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-nav',
  standalone: true,
  imports: [
    NgClass,
    TranslocoModule,
    RouterLink,
    HomeNav,
    TimePipe,
    TruncatePipe,
    InitialsPipe,
    ToBanglaNumberPipe,
    ResponsiveNav,
    NgxSkeletonLoaderComponent,
    NgOptimizedImage
],
  templateUrl: './nav.component.html',
  styleUrl: './nav.component.scss',
  animations: [
    accordionAnimation,
    dropdownAnimation
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavComponent implements OnInit {
  private transloco = inject(TranslocoService);
  private cookieService = inject(CookieService);
  private localStorageService = inject(LocalstorageService);
  private route = inject(ActivatedRoute);
  private destroyRef = inject(DestroyRef);
  private platformId = inject(PLATFORM_ID);
  private sharedService = inject(SharedService);
  private jobDetailsService = inject(JobDetailService);
  private router = inject(Router);
  private navService = inject(NavServices);
  private scrollService = inject(ScrollService);
  private toaster = inject(ToasterService);
  private bannerService = inject(BannerConfigService)
  private fairService = inject(FairService)
  private activatedRoute = inject(ActivatedRoute);
  private profileCompletionService = inject(ProfileCompletionService)
  environment = environment;
  private deviceDetectionService = inject(DeviceDetectionService);
  isSupportingInfoLoading = signal<boolean>(true);
  isBrowser = signal(isPlatformBrowser(this.platformId));
  imgVersionParams = ImgVersionParams;
  isMybdjobsItemShow = signal(false);
  isProfileShow = signal(false);
  isMessageShow = signal(false);
  isNotificationShow = signal(false);
  isCareerResourceShow = signal(false);
  isMybdjobsRes = signal(false);
  isJobItemShow = signal(false);
  isJobRes = signal(false);
  isCareerResponsive = signal(false);
  isSignOutOpen = signal(false);
  isMenuOpen = signal(false);
  mybdjobsItem = mybdjobsItem;
  jobsItem = jobsItem;
  jobs_url = JOBS_URL;
  isCurrentUrlReady = signal(false);
  currentUrl = signal('');
  readonly isHomePage = computed(
    () => this.isCurrentUrlReady() && this.currentUrl() === '/',
  );
  readonly isNotHomePage = computed(
    () => this.isCurrentUrlReady() && this.currentUrl() !== '/',
  );

  readonly bannerImageLoaded = signal(false)

  notificationUrl = NotificationUrl
  dashBoardUrl = DashboardUrl;
  profileMenuItems = profileMenuItems;
  careerResourceItem = careerResourceItem;
  activeLang = signal<'en' | 'bn'>('en');
  isCorporate = signal(false);
  isHoveringJob = signal(false);
  isHoveringMessage = signal(false);
  isHoveringNotification = signal(false);
  isHoveringCareerResource = signal(false);
  isHoveringProfile = signal(false);
  isHoveringMybdjobs = signal(false);
  signinUrlBangla = 'https://mybdjobs.bdjobs.com/bn/mybdjobs/signinbn.asp';
  signinUrlEnglish = 'https://mybdjobs.bdjobs.com/mybdjobs/signin.asp';
  signinUrl = BdjobsSigninUrl;
  activeNotificationTab = signal<'alerts' | 'reminders'>('alerts');
  isMessageRes = signal(false);
  isNotificationRes = signal(false);
  isPostJobRes = signal(false);
  readonly nmMap = nmMap;
  mybdjobsMsgUrl = EMPLOYER_MSG_URL;
  isEmployerMenuOpen = signal(false);
  isEmployerMenuOpenRes = signal(false);
  iteration = signal([1, 2, 3, 4]);
  singleRowIteration = signal([1, 2, 3, 4, 5, 6, 7, 8])

  pricingPageUrl = PricingPageUrl;

  private bannerCycleIndex = signal(
    this.isBrowser() ? Number(this.localStorageService.getItem('bannerCycleIndex') || 0) : 0
  );

  showBanner = linkedSignal(() => {
    const banner = this.promotionalBanner();
    return (
      this.isProUser() === false &&
      banner !== null &&
      banner.id !== null &&
      this.isBrowser()
    );
  });
  AlertType = AlertType

  @ViewChild('careerDropdown', { static: false }) careerDropdown!: ElementRef;
  @ViewChild('jobDropdown', { static: false }) jobDropdown!: ElementRef;
  @ViewChild('mybdjobsDropdown', { static: false })
  mybdjobsDropdown!: ElementRef;
  @ViewChild('signoutDropdown', { static: false }) signoutDropdown!: ElementRef;
  @ViewChild('notificationPanel', { static: false })
  notificationPanel!: ElementRef;
  @ViewChild('messagePanel', { static: false }) messagePanel!: ElementRef;
  @ViewChild('profileDropdown', { static: false }) profileDropdown!: ElementRef;
  @ViewChild('employerDropdown') employerDropdown?: ElementRef<HTMLElement>;
  employerDropdownRes?: ElementRef<HTMLElement>;

  readonly isAuthenticated = linkedSignal(() => {
    if (this.isBrowser()) {
      const userId = this.cookieService.getCookie(Cookies.MYBDJOBSGID);
      return userId !== null && userId !== '';
    }
    return false;
  });

  readonly mybdjobsGid = decodeURIComponent(this.cookieService.getCookie(Cookies.MYBDJOBSGID) ?? '')

  readonly isJobsOpen = linkedSignal(
    () => this.isJobItemShow() || this.isHoveringJob(),
  );
  readonly isProfileOpen = computed(
    () => this.isProfileShow() || this.isHoveringProfile(),
  );
  readonly isMybdjobsOpen = linkedSignal(
    () => this.isMybdjobsItemShow() || this.isHoveringMybdjobs(),
  );
  readonly isMessageOpen = computed(
    () => this.isMessageShow() || this.isHoveringMessage(),
  );
  readonly isNotificationOpen = computed(
    () => this.isNotificationShow() || this.isHoveringNotification(),
  );
  readonly isCareerResourceOpen = linkedSignal(
    () => this.isCareerResourceShow() || this.isHoveringCareerResource(),
  );

  isMobileDevice = computed(() =>
    this.deviceDetectionService.isMobileOrTablet(),
  );

  isEligibleForPersonalHiring = computed(() => {
    const experience = Number(
      this.supportingInfo()?.currentUser?.experience ?? 0,
    );
    const today = new Date();
    const accountCreated = new Date(this.accountCreated());
    const diffInMs = today.getTime() - accountCreated.getTime();
    const accountDurationInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const eligibleDuration = accountDurationInDays >= 30;
    return eligibleDuration && experience >= 36;
  });

  accountCreated = computed(() => {
    const accountCreat = String(
      this.supportingInfo()?.currentUser?.accountCreationDate ?? '',
    ).trim();
    if (!accountCreat) return '';
    const [datePart, timePart, meridiem] = accountCreat.split(' ');
    const [month, day, year] = datePart.split('/').map(Number);
    const [hour, minutes, seconds] = timePart.split(':').map(Number);
    let hours = hour;

    if (meridiem === 'PM' && hours < 12) hours += 12;
    if (meridiem === 'AM' && hours === 12) hours = 0;

    const dateObj = new Date(
      Date.UTC(year, month - 1, day, hours, minutes, seconds),
    );
    return dateObj.toISOString();
  });

  isProUser = toSignal(
    this.isBrowser()
      ? this.jobDetailsService
          .getIsProUser(
            decodeURIComponent(
              this.cookieService.getCookie(Cookies.MYBDJOBSGID) ?? '',
            ),
          )
          .pipe(startWith(null))
      : of(false),
    { initialValue: false },
  );

  readonly topBanner = computed(() => this.fairService.topBanner());
  queryParams = toSignal(this.route.queryParams, { initialValue: {} });
  readonly mybdjobsItemUrl = computed(() => {
    return !this.isAuthenticated() && this.activeLang() === 'en'
      ? this.signinUrlEnglish
      : this.signinUrlBangla;
  });

  supportingInfo = signal<Value>({} as Value);

  messageObs$ = this.navService.getMessages().pipe(
    map((data) => {
      const eventType = data?.event?.eventType ?? EventStatus.Error;
      if (eventType === EventStatus.Error) {
        return [];
      }
      const messages = data.event?.eventData?.[0]?.value;
      return (messages ?? []).filter((m) => m.unreadMessage > 0);
    }),
    catchError(() => of([])),
  );

  readonly messageList = toSignal(
    this.isBrowser() ? this.messageObs$ : of([]),
    { initialValue: <Message[]>[] },
  );

  private refetch$ = new Subject<void>();

  readonly promotionalBanner = toSignal( this.fairService.promotionalBanner$,
    { initialValue: null }
  );

  refetchNotifications(): void {
    this.refetch$.next();
  }

  private readonly initialNotificationObj = {
    alerts: [],
    totalNotification: 0,
    reminders: [],
    totalUnreadAlerts: 0,
  };

  notificationObs$ = this.navService.getSupportingInfo().pipe(
    finalize(() => this.isSupportingInfoLoading.set(false)),
    catchError(() => {
      this.isAuthenticated.set(false);
      return EMPTY;
    }),
    filter(() => this.isBrowser()),
    tap((res) => {
      const eventType = res?.event?.eventType ?? InvalidEventResponseType;
      this.isAuthenticated.set(eventType !== InvalidEventResponseType);
    }),
    filter(
      (d) =>
        !!d?.event?.eventData?.length &&
        d.event.eventData[0].value?.currentUser?.guid !== null &&
        d.event.eventData[0].value?.currentUser?.guid !== undefined,
    ),
    map((d) => d.event.eventData[0].value),
    tap((res) => this.supportingInfo.set(res)),
    map((v) => v?.currentUser),

    switchMap((cu) =>
      this.refetch$.pipe(
        startWith(void 0), // initial fetch
        switchMap(() =>
          this.navService.getNotificationsValue(cu, this.activeLang()).pipe(
            catchError(() =>
              of({
                event: {
                  eventType: InvalidEventResponseType,
                  eventData: [
                    {
                      value: this.initialNotificationObj,
                    },
                  ],
                },
              }),
            ),
            map((data) => {
              const eventType = data?.event?.eventType ?? InvalidEventResponseType;
              if (eventType === InvalidEventResponseType) {
                return { alerts: [], totalNotification: 0, reminders: [] };
              }
              return data.event?.eventData?.[0]?.value ?? {
                alerts: [],
                totalNotification: 0,
                reminders: [],
              };
            }),
            map((notif) => {
              const alerts = (notif.alerts ?? []).map((a) => ({
                ...a,
                icon: ALERT_ICON_BY_TITLE[a.notificationType],
              }));
              return {
                ...notif,
                alerts,
                totalUnreadAlerts: alerts.filter((a) => a.timestamp === null)
                  .length,
              };
            }),
          ),
        ),
      ),
    ),
  );

  readonly notifications = toSignal(
    this.isBrowser() ? this.notificationObs$ : of(this.initialNotificationObj),
    {
      initialValue: this.initialNotificationObj,
    },
  );

  maintenaceBanner = toSignal(
    this.bannerService.getMaintenance()
      .pipe(
        map((response) => {
          const maintenance = response.maintenance;
          const active = isMaintenaceActive(maintenance.startAt, maintenance.endAt);

          const activeBanner = maintenance.banners.find(
            (banner) => {
              if (active && banner.status === maintenance.status){
                const isChildActive = isMaintenaceActive(banner.startAt,banner.endAt);
                return isChildActive;
              }
              return false;
            }
          )
          return activeBanner;
        }),
        catchError(() => of({} as MaintenaceBanner))
      ), {
    initialValue: null
    }
  )
  constructor() {
      this.router.events
      .pipe(filter((event) => event instanceof NavigationStart || event instanceof NavigationEnd))
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.isCurrentUrlReady.set(false);
        }

        if (event instanceof NavigationEnd) {
          this.currentUrl.set(event.urlAfterRedirects || event.url);
          this.isCurrentUrlReady.set(true);
        }
      });
  }

  editProfilePercentage = this.profileCompletionService.editProfilePercentage;
  videoCvPercentage = this.profileCompletionService.videoCvPercentage;
  profileCompletion = this.profileCompletionService.profileCompletion;

  ngOnInit(): void {
    if(this.isBrowser()){
      setTimeout(() => {
        this.bannerImageLoaded.set(true);
      }, 500);
    }

    const storedLang: 'en' | 'bn' =
      (this.localStorageService.getItem('ln') as 'en' | 'bn') || 'en';
    this.transloco.setActiveLang(storedLang);
    this.activeLang.set(storedLang);
    this.transloco.langChanges$.subscribe((lang) => {
      this.activeLang.set(lang as 'en' | 'bn');
      this.refetchNotifications();
    });

    this.route.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        if (params['src'] === 'recruiter.bdjobs.com') {
          this.isCorporate.set(true);
        }
        if (params['lang'] === 'bn') {
          this.transloco.setActiveLang('bn');
          this.localStorageService.setItem('ln', 'bn');
        }
        if (params['lang'] === 'en') {
          this.transloco.setActiveLang('en');
          this.localStorageService.setItem('ln', 'en');
        }
      });
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (
      this.careerDropdown !== null &&
      this.careerDropdown !== undefined &&
      !(this.careerDropdown.nativeElement as HTMLElement).contains(
        event.target as Node,
      )
    ) {
      this.isCareerResourceShow.set(false);
    }
    if (
      this.jobDropdown !== null &&
      this.jobDropdown !== undefined &&
      !(this.jobDropdown.nativeElement as HTMLElement).contains(
        event.target as Node,
      )
    ) {
      this.isJobItemShow.set(false);
    }
    if (
      this.mybdjobsDropdown !== null &&
      this.mybdjobsDropdown !== undefined &&
      !(this.mybdjobsDropdown?.nativeElement as HTMLElement).contains(
        event.target as Node,
      )
    ) {
      this.isMybdjobsItemShow.set(false);
    }
    if (
      this.signoutDropdown !== null &&
      this.signoutDropdown !== undefined &&
      !(this.signoutDropdown.nativeElement as HTMLElement).contains(
        event.target as Node,
      )
    ) {
      this.isSignOutOpen.set(false);
    }

    if (
      this.isNotificationShow() &&
      this.notificationPanel !== null &&
      this.notificationPanel !== undefined &&
      !(this.notificationPanel.nativeElement as HTMLElement).contains(
        event.target as Node,
      )
    ) {
      this.isNotificationShow.set(!this.isNotificationShow());
    }
    if (
      this.isMessageShow() &&
      this.messagePanel !== null &&
      this.messagePanel !== undefined &&
      !(this.messagePanel.nativeElement as HTMLElement).contains(
        event.target as Node,
      )
    ) {
      this.isMessageShow.set(!this.isMessageShow());
    }
    if (
      this.isProfileShow() &&
      this.profileDropdown !== null &&
      this.profileDropdown !== undefined &&
      !(this.profileDropdown.nativeElement as HTMLElement).contains(
        event.target as Node,
      )
    ) {
      this.isProfileShow.set(false);
      this.isHoveringProfile.set(false);
    }
    if (
      this.isEmployerMenuOpen() &&
      this.employerDropdown !== null &&
      this.employerDropdown !== undefined &&
      !(this.employerDropdown.nativeElement as HTMLElement).contains(
        event.target as Node,
      )
    ) {
      this.isEmployerMenuOpen.set(false);
    }

    if (
      this.isEmployerMenuOpenRes() &&
      this.employerDropdownRes !== null &&
      this.employerDropdownRes !== undefined &&
      !(this.employerDropdownRes.nativeElement as HTMLElement).contains(
        event.target as Node,
      )
    ) {
      this.isEmployerMenuOpenRes.set(false);
    }
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.isMybdjobsOpen.set(false);
    this.isJobsOpen.set(false);
    this.isCareerResourceOpen.set(false);
  }

  toggleLang(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    const newLang = isChecked ? 'bn' : 'en';
    this.transloco.setActiveLang(newLang);
    this.localStorageService.setItem('ln', newLang);
  }

  currentUrlParamsKey: string | null = null;
  private refreshToggle = true;
  timeoutIdJob: ReturnType<typeof setTimeout> | null = null;
  timeoutIdMybdjobs: ReturnType<typeof setTimeout> | null = null;
  timeoutIdProfile: ReturnType<typeof setTimeout> | null = null;
  timeoutIdMessage: ReturnType<typeof setTimeout> | null = null;
  timeoutIdNotification: ReturnType<typeof setTimeout> | null = null;
  timeoutIdCareerResource: ReturnType<typeof setTimeout> | null = null;

  onMouseLeaveJob() {
    if (this.isBrowser()) {
      this.timeoutIdJob = setTimeout(() => {
        this.isHoveringJob.set(false);
      }, 200);
    }
  }

  onMouseEnterJob() {
    this.isCareerResourceShow.set(false);
    this.isHoveringCareerResource.set(false);
    this.isNotificationShow.set(false);
    this.isMybdjobsItemShow.set(false);
    if (this.timeoutIdJob !== null) {
      clearTimeout(this.timeoutIdJob);
      this.timeoutIdJob = null;
    }
    this.isHoveringJob.set(true);
  }

  onMouseLeaveMybdjobs() {
    if (this.isBrowser()) {
      this.timeoutIdMybdjobs = setTimeout(() => {
        this.isHoveringMybdjobs.set(false);
      }, 200);
    }
  }

  onMouseEnterMybdjobs() {
    this.isCareerResourceShow.set(false);
    this.isHoveringCareerResource.set(false);
    this.isJobItemShow.set(false);
    this.isHoveringJob.set(false);

    if (this.timeoutIdMybdjobs !== null) {
      clearTimeout(this.timeoutIdMybdjobs);
      this.timeoutIdMybdjobs = null;
    }
    this.isHoveringMybdjobs.set(true);
  }

  onFilterUrlClick(item: any) {
    if (!this.isProUser() && item.title === 'Early Access Jobs') {
      if (this.isBrowser()) {
        window.location.href =
          'https://mybdjobs.bdjobs.com/bdjobs-pro/bdjobs-pro-package-pricing';
      }
    } else {
      const key = JSON.stringify(item.queryParams);
      const queryParams = { ...item.queryParams };
      if (this.currentUrlParamsKey === key) {
        this.refreshToggle = !this.refreshToggle;
        queryParams._refresh = this.refreshToggle.toString();
      } else {
        this.currentUrlParamsKey = key;
      }
      this.sharedService.resetFilter(true);
      this.router.navigate([item.url], {
        queryParams,
      });
    }
    this.isMenuOpen.set(false);
    this.isJobItemShow.set(false);
    this.isHoveringJob.set(false);
  }

  redirectToHome(): void {
    if (this.isBrowser()) {
      const storedLn = this.localStorageService.getItem('ln');
      if (storedLn === null || storedLn === '') {
        this.localStorageService.setItem('ln', this.activeLang());
      }
      window.location.href =
        'https://www.bdjobs.com/?lang=' + this.activeLang();
    }
  }

  postMarkAllasReadNotification(): void {
    const userObj: UserObj = {
      userGuid: decodeURIComponent(this.cookieService.getCookie(Cookies.MYBDJOBSGID) ?? ''),
      notificationType: NotificationType,
    };
    this.navService.postMarkAllasRead(userObj).subscribe({
      next: (eventType) => {
        if (eventType === EventStatus.Error) {
          this.toaster.open('markReadError', 'error');
        }
        if (eventType === EventStatus.Success) {
          this.refetchNotifications();
          this.toaster.open('markReadSuccess', 'success');
        }
      },
      error: () => {
        this.toaster.open('markReadError', 'error');
      },
    });
  }

  onClickProfile(): void {
    if (!this.isMobileDevice()) {
      this.isProfileShow.set(!this.isProfileShow());
    }
  }

  onClickMessage(): void {
    this.isProfileShow.set(false);
    this.isMenuOpen.set(false);
    this.isNotificationShow.set(false);
    if (this.isMobileDevice()) {
      this.isMessageRes.set(!this.isMessageRes());
    } else {
      this.isMessageShow.set(!this.isMessageShow());
    }
  }

  onClickNotification(): void {
    this.isProfileShow.set(false);
    this.isMenuOpen.set(false);
    this.isMessageShow.set(false);
    if (this.isMobileDevice()) {
      this.isNotificationRes.set(!this.isNotificationRes());
    } else {
      this.isNotificationShow.set(!this.isNotificationShow());
    }
  }

  onCloseNotification(): void {
    this.isNotificationShow.set(false);
  }

  onCloseMessage(): void {
    this.isMessageShow.set(false);
  }

  onMouseEnterCareerResource(): void {
    this.isJobItemShow.set(false);
    this.isHoveringJob.set(false);
    this.isMybdjobsItemShow.set(false);
    this.isHoveringMybdjobs.set(false);

    if (this.timeoutIdCareerResource !== null) {
      clearTimeout(this.timeoutIdCareerResource);
      this.timeoutIdCareerResource = null;
    }
    this.isHoveringCareerResource.set(true);
  }

  onMouseLeaveCareerResource(): void {
    if (this.isBrowser()) {
      this.timeoutIdCareerResource = setTimeout(() => {
        this.isHoveringCareerResource.set(false);
      }, 200);
    }
  }

  redirectNoti(data: Alert | Reminder, isAlert: boolean): void {
    const lang = (this.activeLang() ?? 'en'); //language version
    const v = lang.toUpperCase();
    if (data.notificationType === VIDEO_RESUME || data.notificationType === VIDEO_RESUME_SUGGESTED) {
      this.openUrl(`${VideoCVUrl}?lang=${lang}`);
    }
    const matchedInterview = InterViewType.find(ivType => ivType.title === data.title);
    const matchedType = matchedInterview?.type;

    if (isAlert) {
      const alert = data as Alert;
      if (matchedType !== undefined) {
        const inviteUrl = `${InterView_DETAILS_URL}?id=${alert.metadata?.jP_ID}&i=${matchedType}&lang=${this.activeLang()}`;
        this.openUrl(inviteUrl);
        return;
      }

      const base =
        'https://mybdjobs.bdjobs.com/mybdjobs/filter-notification-message.asp';
      const type = Number(alert.notificationType);

      // const resumeSelected = RESUME_SELECTED;
      // const employerMsg = EMPLOYER_MSG;
      // if (type === resumeSelected) {
      //   window.open(
      //     `${EMPLOYER_INTEREST}?lang=${this.activeLang()}`,
      //     '_blank',
      //   );
      //   return;
      // }

      // if (type === employerMsg) {
      //   window.open(
      //     `${EMPLOYER_MSG_URL}?lang=${this.activeLang()}`,
      //     '_blank',
      //   );
      //   return;
      // }
      // if (type === RESUME_VIEWED || type === VIDEO_RESUME_WATCHED){
      //   window.open(
      //     `${EMPLOYER_VIEWED_CV}?lang=${this.activeLang()}`,
      //     '_blank',
      //   );
      //   return;
      // }

      // if (type === MATCHED_JOB){
      //   window.open(
      //     `${'https://bdjobs.com/h/jobs'}?lang=${this.activeLang()}`,
      //     '_blank',
      //   );
      //   return;
      // }

      // if (type === ALL_NOTIFICATIONS){
      //   window.open(
      //     `${NotificationUrl}?lang=${this.activeLang()}`,
      //     '_blank',
      //   );
      //   return;
      // }
      const config = this.ALERT_URL_MAP[type];

      if (config?.kind === 'direct') {
        this.openUrl(config.url());
        return;
      }

      const nm = nmMap[type] ?? '';

      const j = alert.metadata?.jP_ID;
      const u = alert.metadata?.uniqueID;

      const params = new URLSearchParams();
      if (!(nm === 'cv' || nm === 'vr')) {
        if (j !== null) params.set('j', String(j));
      }
      if (v) params.set('v', v);
      params.set('t', 'n'); // always
      if (nm) params.set('nm', nm);
      if (u !== null) params.set('u', String(u));

      const newUrl = `${base}?${params.toString()}`;
      window.open(newUrl, '_blank');
      // console.log('ii',i, 'ppp', newUrl )
    } else {
      const reminder = data as Reminder;
      const link = reminder.metadata?.link;
      // const type = Number(reminder.notificationType);
      // const nm = nmMap[type] ?? ''; // notification type

      const params = new URLSearchParams();
      params.set('t', 'm'); // always same
      params.set('u', reminder.metadata.messageID.toString());
      params.set('v', v);
      params.set('j', '');
      params.set('nm', 'pm'); // always same , logic from sayem

      const newUrl = `${link}?${params.toString()}`;
      // console.log('redirect', newUrl )
      window.open(newUrl, '_blank');
    }
  }

  onTenderClick(): void {
    this.isMenuOpen.set(false);
    this.scrollService.updateTenderClick(true);
  }

  onClickSignout(): void {
    if(this.isBrowser()) {
      this.localStorageService.deleteAll();
    }
    window.location.href = HOME_SIGNOUT_URL;
  }

  onClickSignin(): void {
    const path = this.router.url.split('?')[0];
    const currentUrl = path.startsWith('/')
      ? path.slice(1).trim()
      : path.trim();
    const lang = this.activeLang();
    if (currentUrl === '') {
      window.location.href = `${BdjobsSigninUrl}?tp=default&lang=${this.activeLang()}`;
    } else if (currentUrl.includes('details')) {
      window.location.href = constructRedirectURL('jd', currentUrl, lang);
    } else if (currentUrl.includes('jobs')) {
      window.location.href = constructRedirectURL('jl', undefined, lang);
    }
    else
    {
      window.location.href = `${BdjobsSigninUrl}?tp=default&lang=${this.activeLang()}`;
    }
  }

  openUrl(url:string):void{
    window.open(url, '_blank');
  }

  onClickMaintenance():void{
    const redirectUrl = this.maintenaceBanner()?.redirectUrl;
    if (typeof redirectUrl === 'string' && redirectUrl.trim() !== '') {
      window.location.href = redirectUrl;
    }
  }

  // hideCareerResource = computed(() => {
  //   const hiddenRoutes = ['/jobs', '/details', '/apply-online'];
  //   const url = this.currentUrl();
  //   return hiddenRoutes.some(route =>
  //     url.startsWith(route)
  //   );
  // })

  ALERT_URL_MAP: Record<number, AlertUrlConfig> = {
    [RESUME_SELECTED]: { kind: 'direct', url: () => `${EMPLOYER_INTEREST}?lang=${this.activeLang()}` },
    [EMPLOYER_MSG]: { kind: 'direct', url: () => `${EMPLOYER_MSG_URL}?lang=${this.activeLang()}` },
    [RESUME_VIEWED]: { kind: 'direct', url: () => `${EMPLOYER_VIEWED_CV}?lang=${this.activeLang()}` },
    [VIDEO_RESUME_WATCHED]: { kind: 'direct', url: () => `${EMPLOYER_VIEWED_CV}?lang=${this.activeLang()}` },
    [MATCHED_JOB]: { kind: 'direct', url: () => `https://bdjobs.com/h/jobs?lang=${this.activeLang()}` },
    [ALL_NOTIFICATIONS]: { kind: 'direct', url: () => `${NotificationUrl}?lang=${this.activeLang()}` },
  };
}
